import { IStyleableProps } from "lib/interfaces/IStyleableProps";
import React from "react";
import styled from "styled-components";
import { IWrapperProps } from "./Wrapper";

export interface IWrapperProps extends IStyleableProps {
  maxWidth?: number | string;
  maxHeight?: number | string;
  minHeight?: number | string;
  minWidth?: number | string;
}
export const Wrapper = (props: IWrapperProps) => {
  const StyledDiv = styled.div`
    max-width: ${props.maxWidth || "auto"};
    max-height: ${props.maxHeight || "auto"};
    min-width: ${props.minWidth || "auto"};
    min-height: ${props.minHeight || "auto"};
  `;
  return (
    <StyledDiv className={props.className ? props.className : undefined}
      // style = {{backgroundImage: "url('landing.png')"}}
    >
      {props.children}
    </StyledDiv>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/utils/wrapper/Wrapper.tsx